import { useRouter } from 'next/router';
import getUserLocale from 'get-user-locale';
import { useEffect } from 'react';

export default function PageIndexRedirection() {
    const router = useRouter();

    useEffect(() => {
        let language = localStorage.getItem('userLanguage');

        // If no language is found in localStorage, determine it from the browser
        if (!language) {
            const userLocale = getUserLocale();
            const browserLang = userLocale.substring(0, 2);
            language = browserLang === 'fr' ? 'French' : 'English';
            localStorage.setItem('userLanguage', language);
        }

        // Redirect based on the language
        if (language === 'French') {
            router.push('/fr/');
        } else {
            router.push('/en/');
        }
    }, [router]);

    return null;
}



// import { useRouter } from 'next/router';
// import getUserLocale from 'get-user-locale';
// export default function pageIndexRedirection() {
//     const router = useRouter();
//     const userLocale = getUserLocale();
//     const browserLang = userLocale.substring(0,2);
//     if (typeof window !== 'undefined') {
//         if(browserLang === `fr`) {
//         router.push(`/fr/`);
//         } else {
//         router.push(`/en/`);
//         }
//     }
// }